// Admin home — small strip of KPI cards.

import React, { useEffect, useState } from 'react';
import { getOverview } from '../adminApi';

export default function Overview() {
    const [data, setData] = useState(null);
    const [err, setErr] = useState(null);

    useEffect(() => {
        let cancelled = false;
        (async () => {
            try {
                const d = await getOverview();
                if (!cancelled) setData(d);
            } catch (e) {
                if (!cancelled) setErr(e?.message || 'Failed to load');
            }
        })();
        return () => { cancelled = true; };
    }, []);

    if (err) return <Err msg={err} />;
    if (!data) return <Loading />;

    return (
        <div>
            <h2 style={styles.h2}>Overview</h2>
            <div style={styles.grid}>
                <Kpi label="Total users" value={fmt(data.total_users)} />
                <Kpi label="Active subscribers" value={fmt(data.active_subscribers)} />
                <Kpi label="New signups · last 7d" value={fmt(data.signups_7d)} />
                <Kpi label="New signups · last 30d" value={fmt(data.signups_30d)} />
                <Kpi label="Avg Capeesh" value={data.av_capeesh_score ?? '—'} accent />
                <Kpi label="Recordings · last 24h" value={fmt(data.recordings_today)} />
            </div>
        </div>
    );
}

function Kpi({ label, value, accent }) {
    return (
        <div style={{ ...styles.card, ...(accent ? styles.cardAccent : null) }}>
            <div style={styles.kpi}>{value}</div>
            <div style={styles.label}>{label}</div>
        </div>
    );
}

function fmt(n) {
    if (n === null || n === undefined) return '—';
    return typeof n === 'number' ? n.toLocaleString() : n;
}

export function Loading() {
    return <div style={{ color: '#888' }}>Loading…</div>;
}
export function Err({ msg }) {
    return <div style={{ color: '#c0392b' }}>Error: {msg}</div>;
}

const styles = {
    h2: { marginTop: 0, color: '#222' },
    grid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: 12 },
    card: {
        backgroundColor: '#fff',
        borderRadius: 14,
        padding: 16,
        minHeight: 90,
        boxShadow: '0 1px 2px rgba(0,0,0,0.04)',
    },
    cardAccent: { borderLeft: '4px solid #27BE78' },
    kpi: { fontSize: 28, fontWeight: 800, color: '#222' },
    label: { fontSize: 12, color: '#888', marginTop: 4, textTransform: 'uppercase', letterSpacing: 0.5 },
};
